import React, { useState } from "react";
import { toast } from "sonner";
import { CreditCard, Plus, Trash2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { api } from "../lib/api";
import { PageHeader } from "../components/PageHeader";

export default function SellerPaymentMethods() {
  const { user, refresh } = useAuth();
  const [methods, setMethods] = useState(user?.payment_methods || []);
  const [name, setName] = useState("");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);

  const save = async (list) => {
    setBusy(true);
    try { await api("/auth/profile", { method: "PUT", body: JSON.stringify({ payment_methods: list }) }); await refresh(); setMethods(list); }
    catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };
  const add = async () => {
    if (!name.trim()) return toast.error("أدخل اسم طريقة الدفع");
    const list = [...methods, { name: name.trim(), details: details.trim(), enabled: true }];
    await save(list); setName(""); setDetails(""); toast.success("تمت الإضافة");
  };
  const remove = async (i) => { await save(methods.filter((_, idx) => idx !== i)); };

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="طرق الدفع الخاصة بمتجري" />
      <div className="bg-white rounded-2xl border border-[#E8EAF2] p-4 mb-4">
        <input data-testid="pm-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="اسم الطريقة (مثال: حوالة مصرف الجمهورية)" className="w-full bg-[#F0F2FA] rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-[#FF3D5A]" />
        <textarea data-testid="pm-details" value={details} onChange={(e) => setDetails(e.target.value)} placeholder="التفاصيل (رقم الحساب / التعليمات)" className="w-full bg-[#F0F2FA] rounded-xl px-4 py-3 mt-2 outline-none focus:ring-2 focus:ring-[#FF3D5A] min-h-[70px]" />
        <button data-testid="pm-add" disabled={busy} onClick={add} className="w-full flex items-center justify-center gap-2 h-11 rounded-xl bg-[#FF3D5A] text-white font-black mt-3"><Plus size={18} /> إضافة</button>
      </div>
      <div className="space-y-2">
        {methods.map((m, i) => (
          <div key={i} className="flex items-start gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2]">
            <CreditCard size={20} className="text-[#FF3D5A] shrink-0 mt-0.5" />
            <div className="flex-1"><p className="font-black text-[#161629]">{m.name}</p>{m.details && <p className="text-sm text-[#6B7280]">{m.details}</p>}</div>
            <button data-testid={`pm-del-${i}`} onClick={() => remove(i)}><Trash2 size={18} className="text-[#FF3D5A]" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
